// extracted by mini-css-extract-plugin
export default {"search":"Pending_search__SLsDc","list":"Pending_list__7FKkN","listItem":"Pending_listItem__z7wIn","listname":"Pending_listname__yyumO","liststatus":"Pending_liststatus__DhE7d"};